export default "__VITE_ASSET__94d36a03__"